import { Dialog, DialogProps } from "../core/components/dialog";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { AppHelper } from "../appHelper"
import { FieldInstance } from "../core/components/field";
import { Config } from "../core/config/config";
import { TextBox } from "../core/components/textBox";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { CRQuestionContext, CRQuestionEntity, CRTranslation } from "./crQuestion";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { lang } from "../../typeinfo/moment";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import React from "react";

export default class TranslationLink extends React.Component<TranslationLinkProps, TranslationLinkState> {
    common = new AppHelper();
    private _factory = ComponentHelper.createFactory();
    //private _currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.setState({ dialogOpen: false }, this._updateEntity);
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500

    };

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            values: [],
            currentLanguageSelection: []
        }
    }

    private _updateEntity = () => {
        let newEntity = this.props.entity;
        newEntity[this.props.translationsField ? this.props.translationsField : "Titles"] = this.state.values;
        Helper.updateEntity(this.props.entity, newEntity);
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "titlesChanged" });
    }

    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }

        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        const labelText = this.props.entity.Released ? Helper.getTranslation("WebSMS.Report.Question.ShowTranslations") : Helper.getTranslation("WebSMS.GeneralSettings.UebersetzungenBearbeiten");

        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this.onLinkClick}>{labelText}</label>
                </div>

            </>
        );
    }

    onLinkClick = () => {
        this.setState({ dialogOpen: true });
    }

    private _createDialog = () => {
        return (
            <Dialog {...this._dialogProps} open={this.state.dialogOpen}>
                <FullHeightContainer>
                    {this._createMultiSelect()}
                    {this._createTextBoxes()}
                </FullHeightContainer>
            </Dialog>
        );
    }

    private _createMultiSelect = () => {
        let props: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        props.value = this.state.currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (_, value) => {
            this.setState({ currentLanguageSelection: value });
        };
        if (this.props.entity.Released) {
            props.onDataLoaded = (_, data: Array<{ Language: number, Sprache: string }>) => {
                const languages = data.filter((language) => {
                    const item = this.state.values.find(f => f.Key.Id === language.Language);
                    return Helper.hasValue(item) && !Helper.isNullOrEmpty(item.Value);
                });
                this.setState({ currentLanguageSelection: languages })
            }
        }

        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.Resource.Sprachen")} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private _createTextBoxes = () => {
        let elemets = [];
        for (let i = 0; i < this.state.currentLanguageSelection.length; i++) {
            const translation = this.state.values.filter(f => f.Key.Id == this.state.currentLanguageSelection[i].Language)[0];
            elemets.push(
                <div key={kendo.guid()} style={{ flexShrink: 0 }}>
                    <FieldInstance label={translation.Key.Name} noHover={true} >
                        <TextBox {...this._createTextBoxProps(translation)} />
                    </FieldInstance>
                </div>
            );
        }
        return elemets;
    }

    private _createTextBoxProps = (translation: CRTranslation) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.name = translation.Key.Name;
        props.onChange = this.handleTextBoxesChances;
        props.value = Helper.getValueOrDefault(translation.Value, "");
        props.disabled = this.props.entity.Released;
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id: number = 0;
        let translations = this.state.values;
        for (let i = 0; i < translations.length; i++) {
            if (field.name === translations[i].Key.Name) {
                id = i;
            }
        }
        translations[id].Value = value;
        this.setState({ values: translations });
    }

    componentDidMount() {
        this.setState({ values: this.props.entity[this.props.translationsField ? this.props.translationsField : "Titles"] });
    }

    render() {
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        const link = this._createLink();
        return (
            <>
                {link}
                {dialog}
            </>
        );
    };
}

interface TranslationLinkProps extends BaseComponentProps {
    context: CRQuestionContext;
    entity: CRQuestionEntity;
    translationsField: string;
}

interface TranslationLinkState {
    dialogOpen: boolean;
    values: CRTranslation[];
    currentLanguageSelection: Array<{ Language: number, Sprache: string }>;
}